import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Popup, Header, Title, Body, Footer } from '@calendly/ui/components/popup'

export const LeaveTabPopup = ({ isOpen, isLoading, onClose, onCancel, onConfirm }) => {
  const { values } = useFormContext()

  return (
    <Popup
      isOpen={isOpen}
      onClose={onClose}
      withCloseButton
    >
      <Header>
        <Title>
          {I18n.t('publisher.meetings.tabs.notes.popup.title')}
        </Title>
      </Header>
      <Body>
        {I18n.t('publisher.meetings.tabs.notes.popup.info')}
      </Body>
      <Footer>
        <Button
          decoration="secondary-danger"
          onClick={onCancel}
        >
          {I18n.t('publisher.meetings.tabs.notes.popup.discard')}
        </Button>
        <Button onClick={() => onConfirm(values)} loading={isLoading}>
          {I18n.t('publisher.meetings.tabs.notes.popup.save')}
        </Button>
      </Footer>
    </Popup>
  )
}
